module.exports = __webpack_public_path__ + "img/icon-article-white.6774bf41.svg";